import { isEmptyVal, safeJSONParse } from '@/utils';
import { includes } from 'lodash';
import { companySetupProductTypeMap } from '@/common/constants';

export default {
  props: {
    eligibleProductTypeJson: {
      type: String,
      default: '[]',
    },
  },
  methods: {
    goCompanySetup() {
      this.$tracking.postPurchase('company setup');
      window.location.href = '/setup-guide';
    },
  },
  computed: {
    companySetupProductTypeList() {
      const eligibleProductType = safeJSONParse(this.eligibleProductTypeJson, []);
      return isEmptyVal(eligibleProductType) ?
        safeJSONParse(this.$config?.('eligibleProductTypeJson') || '[]', [])
        : eligibleProductType;
    },
    companySetupAccount() {
      // setup the numbers of product more than one, should show setup account
      return this.companySetupProductTypeList?.length > 1;
    },
    isJustSetupOneProduct() {
      return (this.companySetupProductTypeList || []).length === 1;
    },
    companySetupPro() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.pro);
    },
    companySetupProPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.pro_plus);
    },
    companySetupBiz() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.biz);
    },
    companySetupBizPlus() {
      return this.isJustSetupOneProduct && includes(this.companySetupProductTypeList, companySetupProductTypeMap.biz_plus);
    },
    companySetupZoomOneName() {
      if (this.companySetupPro) {
        return this.$t('billing.success.setup_zoom_one_pro');
      } else if (this.companySetupProPlus) {
        return this.$t('billing.success.setup_zoom_one_pro_plus');
      } else if (this.companySetupBiz) {
        return this.$t('billing.success.setup_zoom_one_biz');
      } else if (this.companySetupBizPlus) {
        return this.$t('billing.success.setup_zoom_one_biz_plus');
      } else if (this.companySetupAccount) {
        return this.$t('billing.success.setup_zoom_account');
      }

      return '';
    },
    companySetupZoomOneDesc() {
      if (this.companySetupPro) {
        return this.$t('billing.zoom_one_pro.set_up_success_msg');
      } else if (this.companySetupBiz) {
        return this.$t('billing.zoom_one_biz.set_up_success_msg');
      } else if (this.companySetupBizPlus) {
        return this.$t('billing.zobizplus.set_up_new_biz_plus_success_msg');
      } else if (this.companySetupAccount) {
        return this.$t('billing.success.confirmation.set_up_desc');
      }

      return '';
    },
  },
};
